import React from 'react';
import classNames from 'classnames';
import {ThemeProvider} from '@material-ui/core/styles';
import {createTheme} from '@material-ui/core/styles';
import {withStyles} from '@material-ui/core/styles';
import axios from 'axios';
import NavigationDrawerMobile from "../../components/Common/NavigationDrawerMobile.js";
import {withRouter} from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { MuiThemeProvider } from 'material-ui/styles';
import { AuthenticationService } from '../../Services/AuthenticationService';

let globalProps;

const drawerWidth = 241;

const styles = theme => ({
    root: {
        display: 'flex',
        position: 'relative',
    },
    mainAppBar: {
        minHeight: 60,
        paddingLeft: 0
    },
    appBar: {
        backgroundColor: '#FFF !important',
        color: '#6e7b8e !important',
        boxShadow: 'none',
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        })
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth - 60}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    closeImg: {cursor: 'pointer', float: 'right', marginTop: '4px', width: '30px'},
    menuButton: {
        marginLeft: 5,
        marginRight: 13,
    },
    userMenuButton: {
        marginRight: 33,
        fontSize: 16,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        display: 'block',
        backgroundColor: '#005677 !important',
        flexShrink: 0,
        whiteSpace: 'nowrap',
        zIndex: '1202'
    },
    drawerOpen: {
        display: 'block !important',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        backgroundColor: '#004612 !important',
        color: "#FFF !important",
        height: 55,
        paddingTop: 10
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: 57 + 'px',
        [theme.breakpoints.up('sm')]: {
            width: 57 + 'px',
        },
        backgroundColor: '#004612 !important',
        color: "#FFF !important",
    },
    toolbar: {
        display: 'block',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0',
        margin: '0 auto',
        minHeight: '50px !important',
    },
});


class DashboardTemplateMobile extends React.Component {

    constructor(props) {
        super(props);
        globalProps = props;
        
        const authService = AuthenticationService.getInstance();
        if (!authService.isLoggedIn()) {
            globalProps.history.push('/login');
            return false;
        }
        if (!authService.isAdministrator()) {
            authService.denyNonAdministratorAccess();
            return false;
        }
        if (window.location.href.indexOf('inventory/session') < 0) {
            globalProps.history.push('/search');
            window.location.reload();
        } 
        
        this.loadUser();
    }

    loadUser() {
        const authService = AuthenticationService.getInstance();
        const user = authService.getUser();
        
        this.state = {
            user: user,
            loading: false,
            jwtToken: authService.getToken(),
            open: false
        };
    }

    toggleNavDrawer = (isOpen) => {
        if (isOpen) {
            this.setState({open: !this.state.open});
        } else {
            this.setState({open: !isOpen});
        }
    };

    handleDrawerClose = () => {
        try {
            this.setState({open: false});
        } catch (e) {}
    };

    render() {
        const {classes} = this.props;

        return <div>Hello</div>;

        // Create a Material-UI v4 theme
        const theme = createTheme({
            palette: {
                primary: {
                    main: '#1976d2',
                },
                secondary: {
                    main: '#dc004e',
                },
            },
        });

        return (
            <ThemeProvider theme={theme}>
                <div className={classes.root}>
                    <AppBar
                        position="fixed"
                        className={classNames(classes.appBar, {
                            [classes.appBarShift]: this.state.open,
                        })}
                    >
                        <Toolbar disableGutters={!this.state.open} className={classes.mainAppBar}>
                            <span className="dashboard-template-title" onClick={this.toggleNavDrawer}>
                                JXB Performance
                                {this.props.title ?
                                    <span> {this.props.title}</span>
                                    : ''
                                }
                            </span>
                        </Toolbar>
                    </AppBar>
                    <Drawer
                        anchor={'bottom'}
                        variant="permanent"
                        className={classes.drawer}
                        classes={{paper: classes.drawerOpen}}
                        open={true}
                    >
                        <NavigationDrawerMobile open={this.state.open} toggleDrawerCallback={this.toggleNavDrawer}
                                          toggleOrgDrawer={this.toggleOrgDrawer}/>
                    </Drawer>
                    <div className="dashboardBody">
                        {this.props.children}
                        <div style={{width: '100%', display: 'inline-block'}}>
                            <center>&#9400; {new Date().getFullYear()} JXB Performance, All rights reserved.</center>
                        </div>
                    </div>
                </div>
            </ThemeProvider>
        );
    }
}

DashboardTemplateMobile = withRouter(DashboardTemplateMobile);
DashboardTemplateMobile = withStyles(styles, {withTheme: true})(DashboardTemplateMobile);
export default DashboardTemplateMobile;
